export default {
	options: [{
		value: '0',
		label: '上海速元科技有限公司'
	}, {
		value: '1',
		label: '上海速元科技有限公司'
	}],

	searchlist: [{
			prop: "sellerTaxNumber",
			label: '主体税号',
			type: "input"
		},
		{
			prop: "nsrmc",
			label: '企业名称',
			type: "input"
		},
		{
			prop: "fillMonth",
			label: '填表月份',
			type: "datemonth",
			valueformat: 'yyyyMM'
		}
	],
	tableData: [],
	searchdata: {
		sellerTaxNumber: "",
		fillMonth: "",
		tax: "",
	},
	headData: [{
		title: "主体税号",
		prop: "sellerTaxNumber",
		width: 160,
		align: "left"
	},{
		prop: "nsrmc",
		title: '企业名称',
		width: 160,
	}, {
		title: "填表月份",
		prop: "fillMonth",
		width: 80
	}, {
		title: "税额",
		prop: "tax",
		width: 80
	}, {
		title: "备注",
		prop: "remarks",
		width: 160,
		align: "left"
	},{
		title: "操作",
		prop: "cz",
		width: "200",
		fixed:"right",
		custom:true
	},],
	outputData: {
		exportType: "",
		shenbq: "",
	},
	pagination: {
		pageNum: 1,
		pageSize: 50,
		total: 0,
		paginationkey: 0
	}
}
